import React, { useEffect } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import './navmenu.css';
import Logoutlogo from '../../assets/images/Logout.png';
import { useMsal } from '@azure/msal-react';

function NavMenu() {
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const navLinks = [
    { to: '/', label: 'Doctors' },
    // { to: '/send-messages', label: 'Send Messages' }, // ? Send messages button commented
    { to: '/custom-content-template', label: 'Custom Content Template' },
    { to: '/template-activities-log', label: 'Template Activities Log' },
    { to: '/doctors-activities-log', label: 'Doctor’s Activities Log' },
  ];
  const handleLogout = async () => {
    try {
      localStorage.removeItem('accessToken');
      const logoutRequest = {
        account: instance.getAccountByHomeId(accounts[0].homeAccountId),
        postLogoutRedirectUri: "/",
      };
      instance.logoutRedirect(logoutRequest);
    } catch (error) {
      console.error('Logout Error', error);
    }
  };

  return (
    <Navbar expand="lg">
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto align-items-center">
          {navLinks.map(({ to, label }) => (
            <Nav.Link
              key={to}
              as={Link}
              to={to}
              className={`nav-link ${location.pathname === to ? 'active' : ''}`}
            >
              {label}
            </Nav.Link>
            
          ))}
          <Nav.Link className='' >
          <button className="closeBtn logout-btn" onClick={handleLogout}>
            <img src={Logoutlogo} alt="Logout"></img>
            <span style={{ marginLeft: 5 }} >Logout</span>
          </button>
        </Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <div className="LogOutSec">
        {/* <Nav.Link className='' >
          <button className="closeBtn logout-btn" onClick={handleLogout}>
            <img src={Logoutlogo} alt="Logout"></img>
            <span style={{ marginLeft: 5 }} >Logout</span>
          </button>
        </Nav.Link> */}
      </div>
    </Navbar>
  );
}

export default NavMenu;
